import classes from "./Medal.module.scss";


const MedalComplete = () => (
<svg
  // className={classes.medal}
  width="25px"
  height="30px"
  version="1.1"
  viewBox="0 0 25 30"
>
  <defs>
    <linearGradient id="glow" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop stopColor="#FFF" offset="0%">
        <animate
          id="color"
          attributeName="stop-color"
          from="#fff"
          to="#fce669"
          dur="0.8s"
          begin=".2s"
          fill="freeze"
        />
      </stop>
      <stop stopColor="#fff" offset="100%" />
    </linearGradient>

    <linearGradient id="shine" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop stopColor="white" offset="-10%">
        <animate
          attributeName="offset"
          values="-.05;.95"
          dur="2s"
          begin="color.end"
          repeatCount="indefinite"
        />
      </stop>
      <stop stopColor="black" offset="-5%">
        <animate
          attributeName="offset"
          values="0;1"
          dur="2s"
          begin="color.end"
          repeatCount="indefinite"
        />
      </stop>
      <stop stopColor="white" offset="0%">
        <animate
          attributeName="offset"
          values=".05;1.05"
          dur="2s"
          begin="color.end"
          repeatCount="indefinite"
        />
      </stop>
    </linearGradient>

    <mask id="myShiningMask">
      <rect x={50} y={50} width={70} height={70} fill="url(#shine)" />
    </mask>

    {/* Reusable shapes */}
    <circle id="goldCircle" cx={101.31} cy={108.58} r={9.3054} />
    <path
      id="p1Path"
      d="m103.02 100.84-8.375 12.67 1.6106 1.718 8.4824-12.563z"
      fill="#faeaac"
    />
    <path
      id="p1Path2"
      d="m108.75 107.5-6.103 9.2328s0.85783 0.12078 1.2806 0.0587c0.46922-0.0688 1.3425-0.47104 1.3425-0.47104l4.7318-7.4904z"
      fill="#faeaac"
    />
  </defs>

  <g transform="translate(-89.28 -89.28)">
    <rect
      fill="#662d91"
      transform="matrix(0,-1,-1,0,0,0)"
      x={-95.03}
      y={-111.73}
      width={5.7161}
      height={20.525}
      rx={2.858}
      ry={3.7346}
    />
    <rect
      fill="#9149c7"
      transform="rotate(-30)"
      x={30.998}
      y={124.01}
      width={8.2377}
      height={15.264}
      ry={4.1189}
    />
    <rect
      transform="matrix(-0.86603,-0.5,-0.5,0.86603,0,0)"
      x={-144.5}
      y={22.748}
      width={8.2377}
      height={15.264}
      ry={4.1189}
      fill="#7734a9"
    />

    {/* Use reusable elements */}
    <use href="#goldCircle" fill="#ffff" />
    <use href="#goldCircle" fill="#f0c419" mask="url(#myShiningMask)" />

    <use href="#p1Path" />
    <use href="#p1Path2" />

    <path
      id="p2"
      fill="#f3d55e"
      stroke="#dfb50f"
      d="m106.18 106.99v-2.7606a0.60964 0.60964 0 1 0-0.34858 0v2.7426a4.2288 4.2288 0 0 0-1.467-1.2587c-1.1536-0.61081-2.41-0.67647-2.8966-0.67647h-0.3478c-0.48692 0-1.7429 0.0656-2.8973 0.67608a4.2307 4.2307 0 0 0-1.4459 1.2286v-2.7121a0.60964 0.60964 0 1 0-0.34821 0v2.7606a1.1755 1.1755 0 0 0-1.1755 1.1755v0.78393a0.87069 0.87069 0 0 0 0.6753 0.84723 0.85545 0.85545 0 0 0 0.1954 0.0227h0.15235v-0.007c0-2.2123 1.1466-3.2827 2.1103-3.7907 1.0849-0.57447 2.2736-0.63621 2.7356-0.63621h0.0309 0.28409 0.0328c0.46075 0 1.6491 0.0617 2.7356 0.63621 0.96173 0.50804 2.1103 1.5792 2.1103 3.7907v0.007h0.17399a0.86404 0.86404 0 0 0 0.6159-0.25518 0.86795 0.86795 0 0 0 0.25519-0.61549v-0.78315a1.1755 1.1755 0 0 0-1.1755-1.1755zm-9.8386-3.3444a0.26144 0.26144 0 1 1 0.26143 0.26105 0.26183 0.26183 0 0 1-0.26143-0.26105zm9.4021 0a0.26144 0.26144 0 1 1 0.26144 0.26105 0.26183 0.26183 0 0 1-0.26066-0.26105z"
    />

    <path
      fill="#f3d55e"
      d="m96.539 109.81c0 3.9411 3.7293 4.1658 4.584 4.1658h0.34585c0.85427 0 4.5824-0.2247 4.5824-4.1658 0-3.9861-3.8161-4.1709-4.6114-4.1658h-0.28957c-0.7937-0.005-4.6113 0.17819-4.6113 4.1658z"
    />
    <rect
      fill="#f2cc34"
      x={97.169}
      y={107.57}
      width={8.275}
      height={4.2612}
      rx={2.1306}
      mask="url(#myShiningMask)"
    />
    <path
      d="m101.31 110.72a1.1165 1.1165 0 0 1-0.37868-0.0653 0.15809 0.15809 0 1 1 0.10624-0.29779 0.82301 0.82301 0 0 0 0.54437 0 0.15818 0.15818 0 1 1 0.10677 0.29779 1.1165 1.1165 0 0 1-0.37868 0.0653z"
      fill="#dfb50f"
    />
    <circle fill="#dfb50f" cx={99.454} cy={109.52} r={0.54789} />
    <circle fill="#dfb50f" cx={103.16} cy={109.52} r={0.54789} />
  </g>

  <circle
    id="c3"
    className={classes.spin}
    transform="rotate(122)"
    cx={11}
    cy={19}
    r={7.8377}
    fill="none"
  />
</svg>
);
export { MedalComplete };